module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAyCAYAAABh7ppAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAf0lEQVQ4y+2UMQ6EMAwE1xQ84F5NCT3dvS/+wtAkEIFzRwlSprKUkSLL0kiSgBFYgAR4nkcVgJkrUy2kQEiSZFlAAWZmg/7QhS504eWCB29eC99AWPepapSHjXo8p8oWjk0ald1ra7mon8YHbq3KFm4dy3+8+6D4UIX1fKjLmhvUosT03s3sygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/application_detail/pops-waring.png
// module id = 43Hp
// module chunks = 15